'use client';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = theme => ({
  collapseContainer: {
    borderBottom: 0,
    color: theme.palette.primary.textColor3,
    bgcolor: 'transparent',
    boxShadow: 'none',
    borderRadius: 0,
    '& .MuiAccordionSummary-root': {
      display: 'flex',
      boxShadow: 'none',
      justifyContent: 'flex-start',
      alignItems: 'center',
      '& .MuiAccordionSummary-content': {
        flexGrow: '0',
      },
    },
    '&:before': {
      backgroundColor: 'transparent',
    },
  },
  details: {
    borderBottom: 'none',
    bgcolor: 'transparent',
    boxShadow: 'none',
    borderRadius: 0,
  },
  descriptionText: {
    color: theme.palette.default.textColor3,
  },
  title: {
    color: theme.palette.default.textColor3,
  },
  summary: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
});
